export default __webpack_public_path__ + "static/cover-7200d7fe34abc02c95e3d35505f3fcdb.png";